import { fromJS } from 'immutable';

import { zoomSliderLevels, ZOOM_STORAGE_KEY } from '../ZoomConstants';
import AppStorage from '@Services/AppStorage';


export function validateStateFromStorage (state) {
  if (!state) {
    return zoomSliderLevels.defaultForKey;
  }

  for (const prop in state) {
    if (isNaN(state[prop])) {
      return zoomSliderLevels.defaultForKey;
    }
  }

  return state;
}

const fromStorage = validateStateFromStorage(
  AppStorage.instance.get(ZOOM_STORAGE_KEY)
);

const initialState = fromJS(
  fromStorage
);


export default initialState;
